import { requestApi } from "../axios";
const prefix = 'user-profile';

export function getUserListApi(offset, search) {
    return requestApi(`${prefix}/list-user?limit=10&offset=${offset}`, 'POST', { search });
}

export function getTotalUserCountApi(search) {
    return requestApi(`${prefix}/total-user-count`, 'POST', { search });
}